export default __webpack_public_path__ + "static/media/question.ddccce9a.png";